import setupV2Theme from "./theme/setupV2Theme";

export const setThemeColors = (chatCustomizationSettings) => {
    if (chatCustomizationSettings.isVersionV2) {
        setupV2Theme(chatCustomizationSettings.versionV2Theme);
    } else {
        if (chatCustomizationSettings.preferredThemeColor === "custom") {
            const {
                themeColor1,
                themeColor2,
                themeColor3,
                themeColor4, // text color
                themeColor5,
                themeColor6,
                themeColor7,
                chatBubbleBackground,
                chatBubbleVisitorBackground,
                chatBubbleText,
                chatBubbleVisitorText,
            } = chatCustomizationSettings;
            setColors(
                themeColor1,
                themeColor2,
                themeColor3,
                themeColor4,
                themeColor5,
                themeColor6,
                themeColor7,
                chatBubbleBackground,
                chatBubbleVisitorBackground,
                chatBubbleText,
                chatBubbleVisitorText
            );
        } else {
            setColors(...preConfiguredThemes[chatCustomizationSettings.preferredThemeColor]);
        }
    }
};
const setColors = (
    color1,
    color2,
    color3,
    color4, // text color
    color5,
    color6,
    color7,
    chatBubbleBackground = "#ffffff",
    chatBubbleVisitorBackground = "#ffffff",
    chatBubbleText = "#000000",
    chatBubbleVisitorText = "#000000"
) => {
    const r = document.querySelector(":root");

    r.style.setProperty("--color1", color1);
    r.style.setProperty("--color2", color2);
    r.style.setProperty("--color3", color3);
    r.style.setProperty("--color4", color4); // text color
    r.style.setProperty("--color5", color5);
    r.style.setProperty("--color6", color6);
    r.style.setProperty("--color7", color7 || color4);
    r.style.setProperty("--customer-text-color", color4); // text color
    r.style.setProperty("--chat-bubble-background", chatBubbleBackground);
    r.style.setProperty("--customer-bubble-color", chatBubbleBackground);
    r.style.setProperty("--chat-bubble-visitor-background", chatBubbleVisitorBackground);
    r.style.setProperty("--chat-bubble-system-background", `${chatBubbleBackground}8f`);
    r.style.setProperty("--chat-bubble-text", chatBubbleText);
    r.style.setProperty("--chat-bubble-visitor-text", chatBubbleVisitorText);
};

const preConfiguredThemes = {
    servquick: ["#485563", "#29323c", "#485563", "#ffffff", "#ff1744", "#29323c"],
    mango: ["#ffe259", "#ffa751", "#ffe259", "#ffffff", "#ff1744", "#ffa751"],
    black: ["#000000", "#0d2226", "#000000", "#ffffff", "#ff1744", "#0d2226"],
    green: ["#006319", "#006311", "#006311", "#ffffff", "#ff1744", "#006319"],
    gray: ["#2e2e2e", "#424242", "#424242", "#ffffff", "#ff1744", "#2e2e2e"],
    red: ["#bf0400", "#910704", "#bf0400", "#ffffff", "#2e2e2e", "#910704"],
    yellow: ["#666400", "#a3a007", "#a3a007", "#ffffff", "#ff1744", "#666400"],
    orange: ["#f46b45", "#eea849", "#f46b45", "#ffffff", "#2e2e2e", "#eea849"],
    purple: ["#2b004a", "#2b004a", "#2b004a", "#ffffff", "#ff1744", "#2b004a"],
    pink: ["#b3004d", "#b3004d", "#b3004d", "#ffffff", "#2e2e2e", "#b3004d"],
    blue: ["#380036", "#0cbaba", "#0cbaba", "#ffffff", "#ff1744", "#380036"],
};



// WEBPACK FOOTER //
// ./src/utils/setThemeColors.js